import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AutoReplyState {
  showConfigModal: boolean;
  autoReplyEnabled: boolean;
  subject: string;
  emailContent: string;
  delay: number;
  frequency: 'once' | 'daily' | 'weekly';
}

const initialState: AutoReplyState = {
  showConfigModal: false,
  autoReplyEnabled: false,
  subject: 'Thank you for your message',
  emailContent: '<p>Thank you for contacting us. We have received your message and will get back to you as soon as possible.</p>',
  delay: 0,
  frequency: 'once',
};

const autoReplySlice = createSlice({
  name: 'autoReply',
  initialState,
  reducers: {
    setShowConfigModal: (state, action: PayloadAction<boolean>) => {
      state.showConfigModal = action.payload;
    },
    setAutoReplyEnabled: (state, action: PayloadAction<boolean>) => {
      state.autoReplyEnabled = action.payload;
    },
    setSubject: (state, action: PayloadAction<string>) => {
      state.subject = action.payload;
    },
    setEmailContent: (state, action: PayloadAction<string>) => {
      state.emailContent = action.payload;
    },
    setDelay: (state, action: PayloadAction<number>) => {
      state.delay = action.payload;
    },
    setFrequency: (state, action: PayloadAction<'once' | 'daily' | 'weekly'>) => {
      state.frequency = action.payload;
    },
  },
});

export const {
  setShowConfigModal,
  setAutoReplyEnabled,
  setSubject,
  setEmailContent,
  setDelay,
  setFrequency,
} = autoReplySlice.actions;

// Selectors
export const selectShowConfigModal = (state: { autoReply: AutoReplyState }) => state.autoReply.showConfigModal;
export const selectAutoReplyEnabled = (state: { autoReply: AutoReplyState }) => state.autoReply.autoReplyEnabled;
export const selectSubject = (state: { autoReply: AutoReplyState }) => state.autoReply.subject;
export const selectEmailContent = (state: { autoReply: AutoReplyState }) => state.autoReply.emailContent;
export const selectDelay = (state: { autoReply: AutoReplyState }) => state.autoReply.delay;
export const selectFrequency = (state: { autoReply: AutoReplyState }) => state.autoReply.frequency;

export default autoReplySlice.reducer;